import React from 'react'
import { Sidebar } from '../Sidebar/Sidebar'
import './Layout.css'

interface LayoutProps {
  children: React.ReactNode
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="layout-container">
      <Sidebar />
      <div className="layout-content">
        {children}
      </div>
    </div>
  )
}